import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_PARTNERS,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';

const defaultTrackEvent = {
  type: GPX_EVENT_TYPES.CLICK,
  feature: GPX_FEATURES.RCS911,
  capability: GPX_CAPABILITIES.TT911,
  route: GPX_ROUTES.COMMUNICATOR,
  partner: GPX_PARTNERS.GOOGLE,
};

export const trackViewAllPreconfiguredResponses = (conversationID: string) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'open_preconfigured_responses',
    entities: {
      conversationID,
    },
  });
};

export const trackCloseAllMessagesModal = (conversationID: string) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'close_preconfigured_responses',
    entities: {
      conversationID,
    },
  });
};

export const trackSendPreconfiguredResponse = (
  message: PreconfiguredResponse,
  conversationID: string,
) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'send_preconfigured_response',
    entities: {
      title: message.title,
      body: message.body,
      id: message.id,
      conversationID,
    },
  });
};
